// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"19adbecf","592":"885ecc99","952":"73b0a1b9"}[chunkId] + ".chunk.js";
};